<template>
  <div>
    <div :style="{ zIndex: 500 }" class="share-modal">
      <h3 class="share-header">{{ $t('buttons.share') }}</h3>
      <div class="share-items">
        <ShareNetwork class="share-fb" network="facebook" :url="pageURL" :title="playerInfos?.infoOptions?.title"
          :description="playerInfos?.shareOptions?.description"
          :hashtags="playerInfos?.shareOptions?.hashtag?.slice(1)">
          <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M27.5 15C27.5 8.1 21.9 2.5 15 2.5C8.1 2.5 2.5 8.1 2.5 15C2.5 21.05 6.8 26.0875 12.5 27.25V18.75H10V15H12.5V11.875C12.5 9.4625 14.4625 7.5 16.875 7.5H20V11.25H17.5C16.8125 11.25 16.25 11.8125 16.25 12.5V15H20V18.75H16.25V27.4375C22.5625 26.8125 27.5 21.4875 27.5 15Z"
              fill="#fff" />
          </svg>
        </ShareNetwork>
        <ShareNetwork class="share-twitter" network="twitter" :url="pageURL" :title="playerInfos?.infoOptions?.title"
          :hashtags="playerInfos?.shareOptions?.hashtag?.slice(1)">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
            <path
              d="M389.2 48h70.6L305.6 224.2 487 464H345L233.7 318.6 106.5 464H35.8L200.7 275.5 26.8 48H172.4L272.9 180.9 389.2 48zM364.4 421.8h39.1L151.1 88h-42L364.4 421.8z" />
          </svg>
        </ShareNetwork>

        <ShareNetwork class="share-lk" network="linkedin" :url="pageURL" :title="playerInfos?.infoOptions?.title"
          :description="playerInfos?.infoOptions?.description">
          <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M23.75 3.75C24.413 3.75 25.0489 4.01339 25.5178 4.48223C25.9866 4.95107 26.25 5.58696 26.25 6.25V23.75C26.25 24.413 25.9866 25.0489 25.5178 25.5178C25.0489 25.9866 24.413 26.25 23.75 26.25H6.25C5.58696 26.25 4.95107 25.9866 4.48223 25.5178C4.01339 25.0489 3.75 24.413 3.75 23.75V6.25C3.75 5.58696 4.01339 4.95107 4.48223 4.48223C4.95107 4.01339 5.58696 3.75 6.25 3.75H23.75ZM23.125 23.125V16.5C23.125 15.4192 22.6957 14.3828 21.9315 13.6185C21.1672 12.8543 20.1308 12.425 19.05 12.425C17.9875 12.425 16.75 13.075 16.15 14.05V12.6625H12.6625V23.125H16.15V16.9625C16.15 16 16.925 15.2125 17.8875 15.2125C18.3516 15.2125 18.7967 15.3969 19.1249 15.7251C19.4531 16.0533 19.6375 16.4984 19.6375 16.9625V23.125H23.125ZM8.6 10.7C9.15695 10.7 9.6911 10.4788 10.0849 10.0849C10.4788 9.6911 10.7 9.15695 10.7 8.6C10.7 7.4375 9.7625 6.4875 8.6 6.4875C8.03973 6.4875 7.50241 6.71007 7.10624 7.10624C6.71007 7.50241 6.4875 8.03973 6.4875 8.6C6.4875 9.7625 7.4375 10.7 8.6 10.7ZM10.3375 23.125V12.6625H6.875V23.125H10.3375Z"
              fill="#fff" />
          </svg>
        </ShareNetwork>
        <a v-if="playerInfos?.sendMailOptions" class="share-mail"
          :href="`mailto:?subject=${playerInfos?.infoOptions?.title}&body=Video Source URL: ${pageURL}`"
          target="_blank"><svg width="30" height="30" viewBox="0 0 30 30" fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
              d="M25 5H5C3.625 5 2.5125 6.125 2.5125 7.5L2.5 22.5C2.5 23.875 3.625 25 5 25H25C26.375 25 27.5 23.875 27.5 22.5V7.5C27.5 6.125 26.375 5 25 5ZM25 10L15 16.25L5 10V7.5L15 13.75L25 7.5V10Z"
              fill="#fff" />
          </svg></a>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from "vue";
import en from '../../../i18n/en_US'
import fr from '../../../i18n/fr_FR'

export default defineComponent({
  name: "share-modal",
  i18n: {
    messages: {
      en: en,
      fr: fr,
    },
  },
  props: {
    player: {
      required: true,
      type: Object,
    },
    showShareModal: {
      required: true,
      type: Function,
    },
    closeShareModal: {
      type: Function,
    },
    playerInfos: {
      type: Object,
      required: true,
    },
    pageURL: {
      type: String,
      required: true,
    },
  }

});
</script>
<style scoped>
.share-modal {
  display: flex;
  justify-content: center;
  flex-direction: column;
  color: var(--vm-color-three);
  align-items: center;
  width: 100%;
  height: 100%;
  background: var(--vm-color-one-08);
  position: absolute;
}

.share-header {
  padding: 7px 12px;
  text-align: center;
  border-bottom: 1px solid gray;
  width: 20%;
  margin-left: 40px;
}

.share-options {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  list-style: none;
  width: 20%;
}

.selected {
  background-color: var(--vm-color-two-08);
}

.language {
  border: 1px solid var(--vm-color-two-08);
  border-radius: 7px;
  padding: 7px 12px;
  color: var(--vm-color-three);
  transition: all 0.3s ease-in-out;
  cursor: pointer;
  width: 100%;
  text-align: center;
}

.language:not(:last-child) {
  margin-bottom: 5px;
}

.language:hover {
  background-color: var(--vm-color-two-08);
  color: var(--vm-color-three);
}

.share-items {
  display: flex;
  gap: 2em;
}

.share-fb:hover path {
  fill: var(--vm-color-two-08);
}

.share-twitter:hover path {
  fill: var(--vm-color-two-08);
}

.share-lk:hover path {
  fill: var(--vm-color-two-08);
}

.share-mail:hover path {
  fill: var(--vm-color-two-08);
}

@media (max-width: 1500px) {
  .share-options {
    width: 100%;
    margin-right: 40px;
  }

  .language {
    width: 70%;
  }

  .share-header {
    width: 70%;
    margin-right: 40px;
  }
}
</style>
